import {createSlice, createAsyncThunk, current} from "@reduxjs/toolkit";
import { api, apiErrorsHandler } from "../../api/httpclient";
import { addNotification } from "./notificationsslice";
import { setCurrentUser } from "./currentuserslice";
import { notificationDurationShort, notificationDurationMiddle, notificationDurationLong, flattenReportsMenu } from "../../lib/utils";


const initialState = {
    pageLoaded: false, pageDisposed: true,
    processing: false, processingText: "",
    groups: [],
    reports: [],
    addGroup:{
        isOpen: false,
        formKey: (new Date()).toString(),
        id: null,
        title: "",
        icon: 0
    }
};

const reportsMenuPageSlice = createSlice({
    name: "reportsMenuPage",
    initialState: initialState,
    reducers:{
        setInitialState: (state, action) =>  ({...initialState}),

        setProcessing: (state, action) => {
            //payload: {processing=true, processingText=false}, when processing is false, processingText is "" 
            const {processing=true, processingText=""} = action.payload;

            return ({...state, processing: processing, processingText: processing==false ? "" : processingText});
        },

        setPageValue: (state, action) => ({...state, [action.payload.id]: action.payload.value}),

        pageLoaded : (state, action) => {
            //payload: {Groups: , Reports:  }
            const pageState = current(state);

            if (pageState.pageDisposed)
                return state;

            return {...state, 
                pageLoaded: true,
                processing: false, processingText: "",
                reports: action.payload.Reports,
                groups: action.payload.Groups
            };
        },

        entitySaved: (state, action) => {
            //{Groups: [{Id, Title, Icon, OrderId, IsExpanded, Items: [{Id, Title, ReportId, ReferenceKey, OrderId}]}]}
            const pageState = current(state);

            if (pageState.pageDisposed)
                return state;
            return ({
                ...state, 
                groups: [...action.payload.Groups]
            });
        },       

        disposePage: (state, action) => {
            //payload: bool  
            if (action.payload)
                return {...initialState};
            else  
                return {...state, pageDisposed: false};
        },
    }
});

export default reportsMenuPageSlice.reducer;


export const loadPage = (t) => async (dispatch, getState) => {
    //start with initial values
    dispatch(setInitialState());

    //undispose page
    dispatch(disposePage(false));

    //show loader
    dispatch(setProcessing({processing: true, processingText: t("slices.loadingPage")}));

    try{
        var response = await api({            
                url: 'reportsmenu/getreportsmenu',
                method:  'post',
                data: {
                },
                //headers:{'h':'1'}
        });
        
        //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
        if(getState().reportsMenuPage.pageDisposed)
            return;
           
        //it's ok to dispatch here
        let data = response.data.Data;       
       
        dispatch(pageLoaded(data));

        return Promise.resolve(response);
    }
    catch(err)
    {
        //i am here => could be any error included 200 and Succeeded=false        
        return Promise.reject(err);
    }
};

export const saveEntity = (t) => async (dispatch, getState) => {
    const pageState = getState().reportsMenuPage;
    
    let url = "reportsmenu/savereportsmenu";

    //show loader
    dispatch(setProcessing({processing: true, processingText: t("slices.savingMenu")}));

    try{
        let processedData = {
            groups: pageState.groups.map(e => ({Title: e.Title, Icon: e.Icon, IsExpanded: e.IsExpanded, items: e.Items.map(i => i.ReportId) }))
        };

        var response = await api({            
            url:url,
            method:  'post',
            data: processedData,
            //headers:{'h':'1'}
        });

        //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
        if(getState().reportsMenuPage.pageDisposed)
           return;

        let data = response.data.Data;

        dispatch(entitySaved(data));
        
        let successMessage = t("slices.savedMenu");

        dispatch(addNotification({text: successMessage, type: "success", closable: true, duration:notificationDurationMiddle, position:"topRight"}));

        const currentUser = getState().currentUser;

        dispatch(setCurrentUser({...currentUser, ReportsMenu: flattenReportsMenu(data.Groups)}));

        dispatch(setProcessing({processing: false}));

        return Promise.resolve(response);
    }
    catch(err)
    {
        //i am here => could be any error included 200 and Succeeded=false
        return Promise.reject(err);
    }
};

export const { setInitialState, setProcessing, setPageValue, pageLoaded, entitySaved, disposePage } = reportsMenuPageSlice.actions;

